import { Alert, Paper, Typography } from '@mui/material';
import { ISubmission, SubmissionStatus } from 'types/submissions';
import { useTranslation } from 'react-i18next';
import { formatTimeStampToDateWithTime } from 'hooks/date/formattedTime';

export function SubmissionStatusIndicator({ submission }: { submission: ISubmission }) {
  const { t } = useTranslation()
  const isSubmitted = submission.submittedAt !== null;

  if (!isSubmitted) {
    return null;
  }

  const { submittedAt } = submission;

  return (
    <Paper sx={{ p: 3, }}>
      <Alert severity="success">
        <Typography>
          {t('submission-success')}
        </Typography>
        {submittedAt && (
          <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
            {t('submitted-at')}{' '}{formatTimeStampToDateWithTime(submittedAt)}
          </Typography>
        )}
      </Alert>
    </Paper>
  )
}
